import React, { useState, useMemo, useEffect } from "react";

const CourseDetailChapterListForAdmin = ({
  curriculumDataList,
  chapters,
  setCurriculumDataList,
}) => {
  const [currentChapterIndex, setCurrentChapterIndex] = useState(1);
  const [completedChapters, setCompletedChapters] = useState(new Set([0]));

  useMemo(() => {
    const newCompletedChapters = new Set(completedChapters);
    for (let i = 0; i < currentChapterIndex; i++) {
      newCompletedChapters.add(i);
    }
    setCompletedChapters(newCompletedChapters);
  }, [currentChapterIndex]);

  const updatedChapters = useMemo(() => {
    return (
      chapters &&
      chapters.map((chapter, index) => ({
        ...chapter,
        status:
          index === currentChapterIndex
            ? "Inprogress"
            : completedChapters.has(index)
            ? "Completed"
            : "Not Complete",
      }))
    );
  }, [currentChapterIndex, completedChapters]);

  const handleChapterClick = (index) => {
    setCurrentChapterIndex(index);
  };

  useEffect(() => {
    if (
      chapters &&
      setCurriculumDataList &&
      chapters.length &&
      chapters[0].status === "Not Complete"
    ) {
      setCurriculumDataList(chapters[0]);
    }
  }, [chapters, setCurriculumDataList]);

  return (
    <div className="chapters">
      {chapters &&
        chapters.map((chapter, index) => {
          let statusClass = "";

          if (chapter.status === "Inprogress") {
            statusClass = "inprogress";
          } else if (chapter.status === "Completed") {
            statusClass = "completed";
          } else if (
            (index === 0 || index > 0) &&
            chapter.status === "Not Complete"
          ) {
            statusClass = "inprogress";
          }

          return (
            <div
              key={index}
              className={`chapter-card py-12 px-12 px-sm-20 mb-11 d-flex align-items-center 
                ${
                // chapter.status === "In Progress" ? "inprogress" : statusClass
                curriculumDataList.name === chapter.name ? "inprogress" : ""
              }`}
            //   style={{ cursor: chapter.status === "Locked" && "no-drop" }}
              onClick={() => {
                if (window.location.pathname !== "/student-courses-detail") {
                //   if (chapter.status !== "Locked") {
                    handleChapterClick(index);
                    setCurriculumDataList(chapter);
                //   }
                }
              }}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <div className="ah-text-lg fw-semibold chapter-title">
                    {index + 1}. {chapter.name}
                  </div>
                  {/* <div className="ah-text-base fw-normal chapter-status">
                    {window.location.pathname !== "/student-courses-detail" ? (
                      <>
                        {index === 0 && chapter.status === "Not Complete"
                          ? "Let's Start"
                          : index > 0 && chapter.status === "Not Complete"
                          ? "Continue"
                          : chapter.status}
                      </>
                    ) : chapter.status}
                  </div> */}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default CourseDetailChapterListForAdmin;
